




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ElementCountryFlag extends Vue {
  @Prop({ required: true }) private countryCode!: string;

  get flag() {
    const c = this.countryCode;
    switch (c) {
      case 'en':
        return 'gb';
      default:
        return c;
    }
  }
}
